import { Route } from 'react-router-dom';
import OrdenPago from './OrdenPago';
import ListarOrdenPagoComponente from './Listar-odp';
import AsignarOrdenPagoComponente from './Asignar';

const OrdePagoRouter = (
  <Route path="ordenpago" element={<OrdenPago />}>
    <Route path="" element={<ListarOrdenPagoComponente />} />
    <Route path=":id/asignar" element={<AsignarOrdenPagoComponente />} />
  </Route>
);

export default OrdePagoRouter;
